import { render, staticRenderFns } from "./CreateEditCompany.vue?vue&type=template&id=b42b3cce&"
import script from "./CreateEditCompany.vue?vue&type=script&lang=js&"
export * from "./CreateEditCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports